/*eslint-disable*/
import { HamburgerIcon } from "@chakra-ui/icons";
import logo from "assets/img/logo.png";
// chakra imports
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  Img,
  Link,
  Stack,
  Text,
  useDisclosure,
  keyframes,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { SimmmpleLogoWhite } from "components/Icons/Icons";
import { Separator } from "components/Separator/Separator";
import { SidebarHelp } from "components/Sidebar/SidebarHelp";
import PropTypes from "prop-types";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import config from "config";
import InfoBubble from "misc/InfoBubble";

// Animations
const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;

// FUNCTIONS

function Sidebar(props) {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  const mainPanel = React.useRef();
  let variantChange = "0.3s cubic-bezier(0.4, 0, 0.2, 1)";
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    const { sidebarVariant } = props;
    // Chakra Color Mode
    let activeBg = "linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(109, 40, 217, 0.2) 100%)";
    let activeColor = "white";
    let inactiveColor = "rgba(255, 255, 255, 0.8)";
    let sidebarActiveShadow = "0 4px 15px rgba(139, 92, 246, 0.3)";
    let iconBg = "brand.200";
    let iconColor = "white";

    return routes.map((prop, key) => {
      if (prop.invisible) return null;
      if (prop.role && !config.role(prop.role)) return null;
      let currentIconBg = iconBg;
      if (prop.color) {
        currentIconBg = prop.color + ".500";
      }
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <React.Fragment key={key}>
            <Text
              color={activeColor}
              fontWeight='bold'
              mb={{
                xl: "6px",
              }}
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py='8px'>
              {document.documentElement.dir === "rtl"
                ? prop.rtlName
                : prop.name}
            </Text>
            {createLinks(prop.views)}
          </React.Fragment>
        );
      }
      return (
        <NavLink to={prop.layout + prop.path} key={key}>
          {activeRoute(prop.layout + prop.path) === "active" ? (
            <Button
              boxSize='initial'
              justifyContent='flex-start'
              alignItems='center'
              boxShadow={sidebarActiveShadow}
              bg={activeBg}
              transition={variantChange}
              backdropFilter='blur(10px)'
              mb={{
                xl: "6px",
              }}
              mx={{
                xl: "auto",
              }}
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py='8px'
              borderRadius='15px'
              border="1px solid rgba(139, 92, 246, 0.3)"
              position="relative"
              overflow="hidden"
              _before={{
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "3px",
                bg: "linear-gradient(180deg, #8b5cf6, #06b6d4)",
                borderRadius: "0 2px 2px 0",
              }}
              _hover={{
                bg: activeBg,
                transform: "translateX(2px)",
              }}
              w='100%'
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "rgba(139, 92, 246, 0.3)",
                outline: "none",
                boxShadow: "none",
              }}
              _focus={{
                boxShadow: "none",
                outline: "none",
                border: "1px solid rgba(139, 92, 246, 0.3)",
              }}>
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Box>{prop.icon}</Box>
                ) : (
                  <IconBox
                    bg={currentIconBg}
                    color={iconColor}
                    h='30px'
                    w='30px'
                    me='12px'
                    transition={variantChange}
                    boxShadow="0 0 15px rgba(139, 92, 246, 0.4)">
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={activeColor} my='auto' fontSize='sm' fontWeight="600">
                  {document.documentElement.dir === "rtl"
                    ? prop.rtlName
                    : prop.name}
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button
              boxSize='initial'
              justifyContent='flex-start'
              alignItems='center'
              bg='transparent'
              border='none'
              mb={{
                xl: "6px",
              }}
              mx={{
                xl: "auto",
              }}
              py='8px'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              borderRadius='15px'
              transition={variantChange}
              _hover={{ 
                bg: "rgba(255, 255, 255, 0.05)",
                transform: "translateX(4px)",
              }}
              w='100%'
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
                outline: "none",
                boxShadow: "none",
              }}
              _focus={{
                boxShadow: "none",
                outline: "none",
                border: "none",
              }}>
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Box>{prop.icon}</Box>
                ) : (
                  <IconBox
                    bg={prop.color ? prop.color + ".500" : "rgba(139, 92, 246, 0.3)"}
                    color={iconColor}
                    h='30px'
                    w='30px'
                    me='12px'
                    transition={variantChange}>
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={inactiveColor} my='auto' fontSize='sm' fontWeight="500">
                  {document.documentElement.dir === "rtl"
                    ? prop.rtlName
                    : prop.name}
                </Text>
              </Flex>
            </Button>
          )}
        </NavLink>
      );
    });
  };
  const { logoText, routes, sidebarVariant } = props;

  var links = <>{createLinks(routes)}</>;
  //  BRAND
  //  Chakra Color Mode
  let sidebarBg =
    "linear-gradient(135deg, rgba(6, 11, 38, 0.95) 0%, rgba(26, 31, 55, 0.9) 100%)";
  let sidebarRadius = "20px";
  let sidebarMargins = "16px 0px 16px 16px";
  var brand = (
    <Box pt={"30px"} display='flex' flexDirection='column' alignItems='center'>
      <Box 
        animation={`${pulse} 4s ease-in-out infinite`}
        transition="all 0.3s ease"
        _hover={{
          transform: "scale(1.05)",
          filter: "drop-shadow(0 0 15px rgba(139, 92, 246, 0.5))",
        }}
      >
        <Img
          src={config.logo ? config.logo : logo}
          width="125px"
          alt="Logo"
          borderRadius={sidebarRadius}
          onError={(e) => { e.target.src = logo; }}
        />
      </Box>
      <Link
        href={`${process.env.PUBLIC_URL}/#/`}
        target='_blank'
        display='flex'
        lineHeight='100%'
        mt='10px'
        mb='20px'
        fontWeight='bold'
        justifyContent='center'
        alignItems='center'
        fontSize='32'>
        <Box
          bgGradient='linear(to-r, white, gray.300)'
          bgClip='text'>
          <Text fontSize='32px' letterSpacing='3px' mt='3px' color='transparent' textAlign={"center"}>
            {logoText}
          </Text>
          <Text fontSize='14px' letterSpacing='3px' mt='3px' color='transparent' textAlign={"center"}>
            {config.tenantName}
          </Text>
        </Box>
      </Link>
    </Box>
  );

  // SIDEBAR
  return (
    <Box ref={mainPanel}>
      <Box display={{ sm: "none", xl: "block" }} position='fixed'>
        <Box
          bg={sidebarBg}
          backdropFilter='blur(20px)'
          transition={variantChange}
          w='260px'
          maxW='260px'
          ms={{
            sm: "16px",
          }}
          my={{
            sm: "16px",
          }}
          h='calc(100vh - 32px)'
          ps='20px'
          pe='20px'
          m={sidebarMargins}
          borderRadius={sidebarRadius}
          border="1px solid rgba(255, 255, 255, 0.05)"
          boxShadow="0 8px 32px 0 rgba(0, 0, 0, 0.37)"
        >
          <Box>{brand}</Box>
          <Stack direction='column' mb='40px'>
            <Box>{links}</Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}

// FUNCTIONS

export function SidebarResponsive(props) {
  // to check for active links and opened collapses
  let location = useLocation();
  // this is for the rest of the collapses
  const [state, setState] = React.useState({});
  const mainPanel = React.useRef();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    // Chakra Color Mode
    const activeBg = "linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(109, 40, 217, 0.2) 100%)";
    const inactiveBg = "transparent";
    const activeColor = "white";
    const inactiveColor = "rgba(255, 255, 255, 0.8)";

    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <React.Fragment key={key}>
            <Text
              color={activeColor}
              fontWeight='bold'
              mb={{
                xl: "6px",
              }}
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py='8px'>
              {document.documentElement.dir === "rtl"
                ? prop.rtlName
                : prop.name}
            </Text>
            {createLinks(prop.views)}
          </React.Fragment>
        );
      }
      return (
        <NavLink to={prop.layout + prop.path} key={key}>
          {activeRoute(prop.layout + prop.path) === "active" ? (
            <Button
              boxSize='initial'
              justifyContent='flex-start'
              alignItems='center'
              bg={activeBg}
              mb={{
                xl: "6px",
              }}
              mx={{
                xl: "auto",
              }}
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              py='8px'
              borderRadius='15px'
              border="1px solid rgba(139, 92, 246, 0.3)"
              _hover='none'
              w='100%'
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "rgba(139, 92, 246, 0.3)",
                outline: "none",
                boxShadow: "none",
              }}
              _focus={{
                boxShadow: "none",
                outline: "none",
                border: "1px solid rgba(139, 92, 246, 0.3)",
              }}>
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Box>{prop.icon}</Box>
                ) : (
                  <IconBox
                    bg='brand.200'
                    color='white'
                    h='30px'
                    w='30px'
                    me='12px'>
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={activeColor} my='auto' fontSize='sm' fontWeight="600">
                  {document.documentElement.dir === "rtl"
                    ? prop.rtlName
                    : prop.name}
                </Text>
              </Flex>
            </Button>
          ) : (
            <Button
              boxSize='initial'
              justifyContent='flex-start'
              alignItems='center'
              bg='transparent'
              border='none'
              mb={{
                xl: "6px",
              }}
              mx={{
                xl: "auto",
              }}
              py='8px'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              borderRadius='15px'
              _hover={{ bg: "rgba(255, 255, 255, 0.05)" }}
              w='100%'
              _active={{
                bg: "inherit",
                transform: "none",
                borderColor: "transparent",
                outline: "none",
                boxShadow: "none",
              }}
              _focus={{
                boxShadow: "none",
                outline: "none",
                border: "none",
              }}>
              <Flex>
                {typeof prop.icon === "string" ? (
                  <Box>{prop.icon}</Box>
                ) : (
                  <IconBox
                    bg="rgba(139, 92, 246, 0.3)"
                    color='brand.200'
                    h='30px'
                    w='30px'
                    me='12px'>
                    {prop.icon}
                  </IconBox>
                )}
                <Text color={inactiveColor} my='auto' fontSize='sm'>
                  {document.documentElement.dir === "rtl"
                    ? prop.rtlName
                    : prop.name}
                </Text>
              </Flex>
            </Button>
          )}
        </NavLink>
      );
    });
  };
  const { logoText, routes, iconColor, ...rest } = props;

  var links = <>{createLinks(routes)}</>;
  //  BRAND
  //  Chakra Color Mode
  var brand = (
    <Box pt={"35px"} mb='8px'>
      <Link
        href={`${process.env.PUBLIC_URL}/#/`}
        target='_blank'
        display='flex'
        lineHeight='100%'
        mb='30px'
        fontWeight='bold'
        justifyContent='center'
        alignItems='center'
        fontSize='11px'>
        <SimmmpleLogoWhite w='22px' h='22px' me='10px' mt='2px' />
        <Box
          bgGradient='linear(to-r, white, gray.300)'
          bgClip='text'>
          <Text fontSize='sm' letterSpacing='3px' mt='3px' color='transparent'>
            {logoText}
          </Text>
        </Box>
      </Link>
      <Separator></Separator>
    </Box>
  );

  // SIDEBAR
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  // Color variables
  return (
    <Flex
      display={{ sm: "flex", xl: "none" }}
      ref={mainPanel}
      alignItems='center'>
      <HamburgerIcon
        color={iconColor}
        w='18px'
        h='18px'
        ref={btnRef}
        colorScheme='teal'
        onClick={onOpen}
      />
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "right" : "left"}
        finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent
          backdropFilter='blur(20px)'
          bg='linear-gradient(135deg, rgba(6, 11, 38, 0.95) 0%, rgba(26, 31, 55, 0.9) 100%)'
          w='250px'
          maxW='250px'
          ms={{
            sm: "16px",
          }}
          my={{
            sm: "16px",
          }}
          borderRadius='20px'
          border="1px solid rgba(255, 255, 255, 0.05)">
          <DrawerCloseButton
            color='white'
            _focus={{ boxShadow: "none" }}
            _hover={{ boxShadow: "none" }}
          />
          <DrawerBody maxW='250px' px='1rem'>
            <Box maxW='100%' h='100vh'>
              <Box>{brand}</Box>
              <Stack direction='column' mb='40px'>
                <Box>{links}</Box>
              </Stack>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
// PROPS

Sidebar.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
};
SidebarResponsive.propTypes = {
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
};

export default Sidebar;
